const CryptoJS = require('crypto-js');

const secretKey = process.env.VUE_APP_BEEREADERS_SECRET_KEY

export default class Utils {
  static decryptData(encryptedText: string, isJson: boolean = true) {
      try {
        const key = CryptoJS.enc.Utf8.parse(secretKey);

        // Decode text encryption from Base64
        const ciphertextBytes = CryptoJS.enc.Base64.parse(encryptedText);

        // Decryption
        const decryptOptions = {
            iv: key,
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        };

        const decryptedBytes = CryptoJS.AES.decrypt(
            { ciphertext: ciphertextBytes },
            key,
            decryptOptions
        );

        // Convert decrypted bytes to text
        const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);

        return isJson ? JSON.parse(decryptedText) : decryptedText
    } catch (e) {
        console.error(e)
    }
  }

  static encryptData(data: any, isJson: boolean = true) {
    try {
      var key = CryptoJS.enc.Utf8.parse(secretKey)

      if (isJson) {
        // Convert data to a JSON string
        data = JSON.stringify(data);
      }

      // Encryption
      var encryptOptions = {
          iv: key,
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
      };

      var encryptedBytes = CryptoJS.AES.encrypt(
          data,
          key,
          encryptOptions
      );

      // Encode ciphertext to Base64
      var encryptedBase64 = encryptedBytes.toString();

      return encryptedBase64;
    } catch (e) {
        console.error(e)
    }
  }

  static encodeBase64UrlSafe(s: string): string {
    const utf8Array = new TextEncoder().encode(s);
    const charArray = Array.from(utf8Array).map(byte => String.fromCharCode(byte)).join('');
    const base64 = btoa(charArray);
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

}
